export const ACTION_LOAD_WIRE__REQUEST = 'ACTION_LOAD_WIRE__REQUEST';
export const ACTION_LOAD_WIRE__SUCCESS = 'ACTION_LOAD_WIRE__SUCCESS';
export const ACTION_LOAD_WIRE__FAIL = 'ACTION_LOAD_WIRE__FAIL';

export const ACTION_EDIT_WIRE__REQUEST = 'ACTION_EDIT_WIRE__REQUEST';
export const ACTION_EDIT_WIRE__SUCCESS = 'ACTION_EDIT_WIRE__SUCCESS';
export const ACTION_EDIT_WIRE__FAIL = 'ACTION_EDIT_WIRE__FAIL';

export const ACTION_CANCEL_WIRE__REQUEST = 'ACTION_CANCEL_WIRE__REQUEST';
export const ACTION_CANCEL_WIRE__SUCCESS = 'ACTION_CANCEL_WIRE__SUCCESS';
export const ACTION_CANCEL_WIRE__FAIL = 'ACTION_CANCEL_WIRE__FAIL';

export const ACTION_LOAD_WIRE_FILE__REQUEST = 'ACTION_LOAD_WIRE_FILE__REQUEST';
export const ACTION_LOAD_WIRE_FILE__SUCCESS = 'ACTION_LOAD_WIRE_FILE__SUCCESS';
export const ACTION_LOAD_WIRE_FILE__FAIL = 'ACTION_LOAD_WIRE_FILE__FAIL';
